import React from "react";
import { useSelector } from "react-redux";
import HeaderMobile from "../includes/HeaderMobile";
import { withRouter, Switch, Route } from "react-router-dom";
import Nav from "../includes/Nav";
import Footer from "../includes/Footer";
import Aside from "../includes/Aside";
import Body from "../includes/Body";
import Error401 from "../pages/Error401";

function App() {
  const languageSelected = useSelector((state) => state.language.languageSelected);

  return (
    <Switch>
      <Route exact path="/error401">
        <Error401 />
      </Route>

      <Route path={"/"}>
        <div className="kt-page-content-white kt-quick-panel--right kt-demo-panel--right kt-offcanvas-panel--right kt-header--fixed kt-header-mobile--fixed kt-subheader--enabled kt-subheader--transparent kt-aside--enabled kt-aside--fixed kt-page--loading">
          <HeaderMobile />

          <div className="kt-grid kt-grid--hor kt-grid--root">
            <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
              <div
                className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper"
                id="kt_wrapper"
                style={{ paddingTop: "0" }}
              >
                <Nav />

                <div
                  className="kt-body kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-grid--stretch"
                  id="kt_body"
                >
                  <div className="kt-container  kt-container--fluid  kt-grid kt-grid--ver">
                    <button className="kt-aside-close " id="kt_aside_close_btn">
                      <i className="la la-close" />
                    </button>

                    <Aside />

                    {/* Remounting on language change forces every page to
                        re-fetch and recompute its data (dropdown options,
                        table labels...) in the new language, instead of
                        leaving stale pre-translated values in state until
                        a manual refresh. */}
                    <Body key={languageSelected} />
                  </div>
                </div>

                <Footer />
              </div>
            </div>
          </div>

          <div id="kt_scrolltop" className="kt-scrolltop">
            <i className="fa fa-arrow-up" />
          </div>
        </div>
      </Route>
    </Switch>
  );
}

export default withRouter(App);
